import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from '@/mastodon/components/intl';
import { IconButton } from '@/mastodon/components/icon_button';
import { Popover } from '@/mastodon/components/popover';

const WorkIcon = (props) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" {...props}>
    <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"/>
  </svg>
);

class ItemPickerMenu extends PureComponent {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onPick: PropTypes.func.isRequired,
  };

  state = {
    loading: true,
    inventory: [],
    othersInventory: [],
    loadingOthers: false,
    error: null,
    searchQuery: '', 
    activeTab: '전체',
    sellItem: null,
    sellQty: 1,
    isSelling: false
  };

  componentDidMount() {
    this.fetchInventory();
  }

  fetchInventory = async () => {
    try {
      const res = await fetch('/my_inventory');
      const data = await res.json();
      
      if (!res.ok || data.error) {
        throw new Error(data.error || "서버 통신 에러");
      }

      this.setState({ inventory: data, loading: false });
    } catch (err) {
      this.setState({ error: err.message, loading: false });
    }
  };

  fetchOthersInventory = async () => {
    this.setState({ loadingOthers: true });
    try {
      const res = await fetch('/my_inventory/others');
      const data = await res.json();
      
      if (!res.ok || data.error) throw new Error(data.error || "서버 통신 에러");

      this.setState({ othersInventory: data, loadingOthers: false });
    } catch (err) {
      this.setState({ error: err.message, loadingOthers: false });
    }
  };

  handleTabClick = (cat) => {
    this.setState({ activeTab: cat });
    if (cat === '타캐릭터' && this.state.othersInventory.length === 0) {
      this.fetchOthersInventory();
    }
  };

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value.toLowerCase() });
  };

  handleClick = (name) => {
    this.props.onPick(name);
  };

  openSellPopup = (e, item) => {
    e.stopPropagation(); 
    e.preventDefault();
    this.setState({ sellItem: item, sellQty: 1 });
  };

  handleSellSubmit = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation(); 
    }
    
    const { sellItem, sellQty } = this.state;
    this.setState({ isSelling: true });
    
    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content;
      const res = await fetch('/my_inventory/sell', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': token
        },
        body: JSON.stringify({
          item_name: sellItem.name,
          count: sellQty,
          sell_price: parseInt(sellItem.sell_price.replace(/,/g, ''), 10)
        })
      });
      
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || '판매에 실패했습니다.');
      
      this.setState({ sellItem: null, sellQty: 1 });
      this.fetchInventory(); 
    } catch (err) {
      alert(err.message);
    } finally {
      this.setState({ isSelling: false });
    }
  };

  render() {
    const { loading, inventory, error, searchQuery, activeTab, sellItem, sellQty, isSelling, othersInventory, loadingOthers } = this.state;

    const filteredInventory = inventory.filter(item => 
      item.name.toLowerCase().includes(searchQuery) || 
      item.desc.toLowerCase().includes(searchQuery) ||
      item.type.toLowerCase().includes(searchQuery)
    );

    const filteredOthersInventory = othersInventory.map(charData => {
      const matchedItems = charData.items.filter(item =>
        item.name.toLowerCase().includes(searchQuery)
      );
      return {
        ...charData,
        items: matchedItems
      };
    }).filter(charData => 
      charData.character.toLowerCase().includes(searchQuery) || charData.items.length > 0
    );

    const types = Array.from(new Set(inventory.map(item => item.type)));
    const categories = ['전체', ...types, '타캐릭터'];
    const displayedItems = activeTab === '전체' 
      ? filteredInventory 
      : filteredInventory.filter(item => item.type === activeTab);

    return (
      <div className="emoji-picker-dropdown__menu" style={{ width: 380, background: 'var(--color-bg-primary)', borderRadius: 4, boxShadow: 'var(--dropdown-shadow)', position: 'relative' }}>
        
        {sellItem && (
          <div 
            onClick={(e) => e.stopPropagation()} 
            style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 4 }}
          >
            <div style={{ background: 'var(--color-bg-primary)', padding: '20px', borderRadius: '8px', width: '80%', color: 'var(--color-text-primary)' }}>
              <h4 style={{ margin: '0 0 10px 0', fontSize: '16px' }}>{sellItem.name} 판매</h4>
              <p style={{ margin: '0 0 15px 0', fontSize: '13px', color: 'var(--color-text-secondary)' }}>
                개당 {sellItem.sell_price} G (보유량: {sellItem.count}개)
              </p>
              
              <input 
                type="number" 
                min="1" max={sellItem.count}
                value={sellQty}
                onChange={(e) => this.setState({ sellQty: Math.max(1, Math.min(sellItem.count, Number(e.target.value))) })}
                style={{ padding: '10px', marginBottom: '15px', background: 'var(--color-bg-secondary)', color: 'var(--color-text-primary)', border: '1px solid var(--color-border-primary)', borderRadius: '4px' }}
              />
              
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                  총 획득: {sellQty * parseInt(sellItem.sell_price.replace(/,/g, ''), 10)} G
                </span>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button 
                    onClick={(e) => { 
                      e.preventDefault();
                      e.stopPropagation(); 
                      this.setState({ sellItem: null }) 
                    }} 
                    style={{ padding: '6px 12px', cursor: 'pointer', background: 'transparent', color: 'var(--color-text-primary)', border: '1px solid var(--color-border-primary)', borderRadius: '4px' }}
                  >
                    취소
                  </button>
                  <button onClick={this.handleSellSubmit} disabled={isSelling} style={{ padding: '6px 12px', cursor: 'pointer', background: 'var(--color-text-brand)', color: '#fff', border: 'none', borderRadius: '4px', fontWeight: 'bold' }}>
                    {isSelling ? '처리중...' : '판매'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="emoji-mart emoji-mart-light" style={{ border: 'none', width: '100%', display: 'flex', flexDirection: 'column', height: 420, background: 'transparent' }}>
          
          <div className="emoji-mart-bar emoji-mart-bar-search" style={{ flexShrink: 0, borderColor: 'var(--color-border-primary)' }}>
            <div className="emoji-mart-search">
              <input 
                type="search" 
                placeholder="소지품 검색..." 
                value={searchQuery}
                onChange={this.handleSearchChange}
                style={{ color: 'var(--color-text-primary)' }}
                autoFocus
              />
            </div>
          </div>

          <div style={{ display: 'flex', overflowX: 'auto', padding: '0 10px', borderBottom: '1px solid var(--color-border-primary)', background: 'var(--color-bg-primary)', flexShrink: 0 }}>
            {categories.map(cat => (
              <button
                key={cat}
                onClick={() => this.handleTabClick(cat)}
                style={{
                  background: 'transparent',
                  color: activeTab === cat ? 'var(--color-text-brand)' : 'var(--color-text-secondary)',
                  border: 'none',
                  borderBottom: activeTab === cat ? '4px solid var(--color-border-brand)' : '4px solid transparent',
                  padding: '12px 10px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                  marginRight: '6px'
                }}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="emoji-mart-scroll" style={{ flexGrow: 1, overflowY: 'auto', padding: 0}}>
            {loading && <div style={{ padding: 15, color: 'var(--color-text-secondary)', textAlign: 'center' }}>가방을 열어보는 중...</div>}
            {error && <div style={{ padding: 15, color: 'var(--color-text-error)', textAlign: 'center' }}>{error}</div>}
            
            {!loading && !error && displayedItems.length === 0 && activeTab !== '타캐릭터' && (
              <div style={{ padding: 15, color: 'var(--color-text-secondary)', textAlign: 'center' }}>아이템이 없습니다.</div>
            )}

            {activeTab === '타캐릭터' ? (
              <div style={{ padding: '10px' }}>
                {loadingOthers && <div style={{ padding: 15, color: 'var(--color-text-secondary)', textAlign: 'center' }}>타캐릭터 소지품 불러오는 중...</div>}
                
                {!loadingOthers && filteredOthersInventory.length === 0 && (
                  <div style={{ padding: 15, color: 'var(--color-text-secondary)', textAlign: 'center' }}>검색 결과가 없습니다.</div>
                )}
                
                {!loadingOthers && filteredOthersInventory.map((charData, idx) => (
                  <div key={idx} style={{ marginBottom: '15px' }}>
                    <div style={{ fontSize: '13px', fontWeight: 'bold', color: 'var(--color-text-secondary)', borderBottom: '1px solid var(--color-border-primary)', paddingBottom: '4px', marginBottom: '8px' }}>
                      {charData.character}
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                      {charData.items.map((item, iIdx) => (
                        <div 
                          key={iIdx} title={item.name}
                          style={{ position: 'relative', width: 44, height: 44, padding: 0, margin: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                            <span dangerouslySetInnerHTML={{ __html: item.formatted_code }} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }} />
                          </span>
                          <span style={{
                            position: 'absolute', bottom: -10, left: -4, zIndex: 9999, fontSize: '11px', fontWeight: '900', color: 'var(--front)',
                            textShadow: '-2px -2px 0 var(--backcolor), 2px -2px 0 var(--backcolor), -2px 2px 0 var(--backcolor), 2px 2px 0 var(--backcolor), -2px 0 0 var(--backcolor), 2px 0 0 var(--backcolor), 0 -2px 0 var(--backcolor), 0 2px 0 var(--backcolor)',
                            pointerEvents: 'none', lineHeight: 1
                          }}>
                            {item.count}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              !loading && !error && displayedItems.length > 0 && (
                activeTab === '전체' ? (
                  <div style={{ display: 'flex', flexWrap: 'wrap', padding: '10px' }}>
                    {displayedItems.map((item, idx) => (
                      <button 
                        key={idx}
                        type="button"
                        className="emoji-mart-emoji"
                        onClick={() => this.handleClick(item.name)}
                        title={item.name}
                        style={{ 
                          position: 'relative',
                          width: 44, height: 44, 
                          padding: 0, margin: 2, border: 'none', background: 'transparent', 
                          cursor: 'pointer', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' 
                        }}
                        onMouseOver={(e) => e.currentTarget.style.background = 'var(--color-bg-secondary)'}
                        onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
                      >
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                          <span dangerouslySetInnerHTML={{ __html: item.formatted_code }} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }} />
                        </span>
                        
                        <span style={{
                          position: 'absolute',
                          bottom: -10,
                          left: -4,
                          zIndex: 9999,
                          fontSize: '11px',
                          fontWeight: '900',
                          color: 'var(--front)',
                          textShadow: '-2px -2px 0 var(--backcolor), 2px -2px 0 var(--backcolor), -2px 2px 0 var(--backcolor), 2px 2px 0 var(--backcolor), -2px 0 0 var(--backcolor), 2px 0 0 var(--backcolor), 0 -2px 0 var(--backcolor), 0 2px 0 var(--backcolor)',
                          pointerEvents: 'none',
                          lineHeight: 1
                        }}>
                          {item.count}
                        </span>
                      </button>
                    ))}
                  </div>
                ) : (
                  <div style={{ padding: '8px' }}>
                    {displayedItems.map((item, idx) => {
                      const isFirst = idx === 0;
                      const isLast = idx === displayedItems.length - 1;
                      
                      return (
                        <div 
                          key={idx}
                          onClick={() => this.handleClick(item.name)}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            width: '100%',
                            padding: '12px 14px',
                            border: '1px solid var(--color-border-primary)',
                            marginBottom: '-1px',
                            borderTopLeftRadius: isFirst ? 4 : 0,
                            borderTopRightRadius: isFirst ? 4 : 0,
                            borderBottomLeftRadius: isLast ? 4 : 0,
                            borderBottomRightRadius: isLast ? 4 : 0,
                            background: 'transparent',
                            color: 'var(--color-text-primary)',
                            textAlign: 'left',
                            cursor: 'pointer'
                          }}
                          onMouseOver={(e) => e.currentTarget.style.background = 'var(--color-bg-secondary)'}
                          onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
                        >
                          <div style={{ display: 'flex', alignItems: 'flex-start', width: '85%' }}>
                            <span dangerouslySetInnerHTML={{ __html: item.formatted_code }} style={{ marginRight: 12, flexShrink: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginTop: 2 }} />
                            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                              <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                                <strong style={{ fontSize: '15px' }}>{item.name}</strong>
                                
                                {item.sell_price && (
                                  <button 
                                    type="button"
                                    onClick={(e) => this.openSellPopup(e, item)}
                                    style={{ 
                                      fontSize: '10px', 
                                      color: 'var(--color-text-warning)', 
                                      background: 'var(--color-bg-warning-softest)', 
                                      padding: '2px 6px', 
                                      borderRadius: '4px',
                                      cursor: 'pointer',
                                      border: '1px solid var(--color-border-warning-soft)' 
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.background = 'var(--color-border-warning-soft)'}
                                    onMouseOut={(e) => e.currentTarget.style.background = 'var(--color-bg-warning-softest)'}
                                  >
                                    판매 : {item.sell_price} G
                                  </button>
                                )}
                              </div>
                              <span className="status__content" style={{ fontSize: '13px', color: 'var(--color-text-secondary)', marginTop: 4, padding: 0 }} dangerouslySetInnerHTML={{ __html: item.desc }} />
                            </div>
                          </div>
                          <div style={{ fontWeight: 'bold', fontSize: '15px', color: 'var(--color-text-brand)', paddingLeft: '10px', whiteSpace: 'nowrap', marginTop: 2 }}>
                            {item.count}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )
              )
            )}
          </div>
        </div>
      </div>
    );
  }
}

class ItemPickerDropdown extends PureComponent {
  static propTypes = {
    onPickItem: PropTypes.func.isRequired,
  };

  state = { active: false, target: null };

  onToggle = (e) => {
    if (!e.key || e.key === 'Enter') this.setState({ active: !this.state.active });
  };

  onHideDropdown = () => this.setState({ active: false });

  setTargetRef = c => this.setState({ target: c });

  render() {
    const { active, target } = this.state;

    return (
      <div className='emoji-picker-dropdown' ref={this.setTargetRef}>
        <IconButton
          title="소지품 확인"
          aria-expanded={active}
          active={active}
          iconComponent={WorkIcon}
          onClick={this.onToggle}
          id="inventory"
          inverted
        />
        <Popover isOpen={active} reference={target} onClose={this.onHideDropdown}>
          {({ props, placement }) => (
            <div {...props} className={`dropdown-animation ${placement}`}>
              <ItemPickerMenu onClose={this.onHideDropdown} onPick={this.props.onPickItem} />
            </div>
          )}
        </Popover>
      </div>
    );
  }
}

export default injectIntl(ItemPickerDropdown);